import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import "./DeleteCompetency.css";

function DeleteCompetency() {
  const [name, setName] = useState();
  const [isLoading, setIsLoading] = useState(true);

  let { cid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/competencies/${cid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setName(response.data.competency.name);
    }
    fetch();
    setIsLoading(false);
  }, []);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/competencies/${cid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/behaviors/competencies");
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col className="delete-competency">
            <Col>
              <h4>{t("Competencias.Competencia.DeleteCompetence.Titulo")}</h4>
            </Col>
            <Col className="delete-competency-form">
              <Col className="mb-1">
                <p>{t("Competencias.Competencia.DeleteCompetence.Pregunta")}</p>
              </Col>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t("Competencias.Competencia.DeleteCompetence.Eliminar")}
                </Button>
                <Button
                  className="danger"
                  onClick={() => navigate("/competencies")}
                >
                  {t("Competencias.Competencia.DeleteCompetence.Cancelar")}
                </Button>
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DeleteCompetency;
